import { generateFieldID } from '@modules/card-helpers';
import type { CardFieldAction } from '@reducers/card-reducers';
import { useCallback } from 'react';
import type { CardUrl, FieldTypes } from 'types';

export default function useAddField(
  cardFieldsDispatch: (value: CardFieldAction) => void,
  onCreate: (id: string) => void,
): (type: FieldTypes, subType: CardUrl['type'] | undefined) => void {
  const handleAddField = useCallback(
    (type: FieldTypes, subType: CardUrl['type'] | undefined) => {
      let id = generateFieldID();

      switch (type) {
        case 'job_title':
          cardFieldsDispatch({ type: 'ADD_JOB_TITLE' });
          id = 'job-title';
          break;
        case 'org_name':
          cardFieldsDispatch({ type: 'ADD_COMPANY' });
          id = 'org-name';
          break;
        case 'department':
          cardFieldsDispatch({ type: 'ADD_DEPARTMENT' });
          id = 'department';
          break;
        case 'accreditations':
          cardFieldsDispatch({ type: 'ADD_ACCREDITATION' });
          id = 'accreditations';
          break;
        case 'headline':
          cardFieldsDispatch({ type: 'ADD_HEADLINE' });
          id = 'headline';
          break;
        case 'phone':
          cardFieldsDispatch({ type: 'ADD_PHONE_NUMBER', id });
          break;
        case 'email':
          cardFieldsDispatch({ type: 'ADD_EMAIL', id });
          break;
        case 'address':
          cardFieldsDispatch({ type: 'ADD_ADDRESS', id });
          break;
        case 'url':
          if (!subType) throw new TypeError('Sub Type not provided for URL field');
          cardFieldsDispatch({ type: 'ADD_URL', urlType: subType, id });
          break;
      }

      onCreate(id);
    },
    [cardFieldsDispatch, onCreate],
  );

  return handleAddField;
}
